import { DocumentNode, Kind } from 'graphql';
import { Operation } from 'urql';

import { MockHandlers } from './mockUtils';

// Helper function to get operation name from GraphQL operation
export const getOperationName = (operation: Operation): string | null => {
  const query = operation.query as DocumentNode;
  // First check if operation has a name (most operations should)
  if (query.definitions.length > 0) {
    const definition = query.definitions[0];
    if (definition.kind === Kind.OPERATION_DEFINITION && definition.name) {
      return definition.name.value;
    }
  }

  // Fallback: extract field name from selections
  const firstDefinition = query.definitions[0];
  if (
    firstDefinition?.kind === Kind.OPERATION_DEFINITION &&
    firstDefinition.selectionSet
  ) {
    const firstSelection = firstDefinition.selectionSet.selections[0];
    if (firstSelection?.kind === Kind.FIELD) {
      return firstSelection.name.value;
    }
  }

  return null;
};

// Helper function to check if an operation should be mocked
export const shouldMockOperation = (
  operation: Operation,
  handlers: MockHandlers,
): boolean => {
  const operationName = getOperationName(operation);
  return operationName ? operationName in handlers : false;
};
